// extracted by mini-css-extract-plugin
export default {"navCategory":"_850e358d","isSelected":"_250d757"};